"use client";

import { motion } from "motion/react";
import { useTranslations } from "next-intl";
import {
	Box,
    Image,
	Stack,
	Typography,
} from "@/components/controls/base-controls";
import {
	HEADER_HEIGHT_FULL,
	WEBPAGE_CORE_CONTAINER,
} from "@/core/constants/webpages";
import useResponsiveImage from "@/core/hooks/use-responsive-image";

const About = () => {
	const t = useTranslations();

	const ladySrc = useResponsiveImage(
		{
			src: "https://general-images.navairra.com/lady_pj_810x772.png",
			width: 388,
			height: 405,
		},
		{
			src: "https://general-images.navairra.com/lady_pj_540x364.png",
			width: 405,
			height: 388,
		},
		{
			src: "https://general-images.navairra.com/lady_pj_810x772.png",
			width: 540,
			height: 364,
		},
		{
			src: "https://general-images.navairra.com/lady_pj_810x772.png",
			width: 810,
			height: 552,
		},
		{
			src: "https://general-images.navairra.com/lady_pj_810x772.png",
			width: 810,
			height: 772,
		},
	);

	return (
        <Box
            sx={{
                backgroundColor: "var(--mui-palette-darkest)",
                width: "100%",
            }}
        >
            <Box
                sx={{
                    margin: "0 auto",
                    width: WEBPAGE_CORE_CONTAINER,
                    maxWidth: "100%",
                    padding: { xs: "2em 0 0", md: "4em 1em" },
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                    gap: { xs: "1em", md: "2em" },
                    height: "100%",
                    maxHeight: {
                        xs: "120svh",
                        md: `calc(100svh - ${HEADER_HEIGHT_FULL})`,
                    },
                    "@media (orientation: landscape)": {
                        maxHeight: {
                            xs: "100%",
                            md: `calc(100svh - ${HEADER_HEIGHT_FULL})`
                        }
                    },
                    overflowY: "hidden",
                }}
            >
                <Stack
                    component={motion.div} 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    direction="column"
                    sx={{
                        padding: { xs: "0 2em 1em", md: "1em 4.5em" },
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        "@media (orientation: landscape)": {
                            padding: { 
                                xs: "2em 2em", 
                                md: "1em 4.5em" 
                            }
                        },
                    }}
                >
                    <Typography
                        variant="h2"
                        sx={{
                            color: "var(--mui-palette-lightest)",
                        }}
                    >
                        {t("about.line11")}
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{
                            margin: "2.5em 0 1em",
                            color: "var(--mui-palette-lightest)",
                        }}
                    >
                        {t("about.line12")}
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{
                            color: "var(--mui-palette-lightest)",
                        }}
                    >
                        {t("about.line13")}
                    </Typography>
                </Stack>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        alignContent: "center",
                        justifyContent: "center",
                        maxHeight: {
                            xs: `calc(60svh - 2em)`,
                            md: `calc(100svh - ${HEADER_HEIGHT_FULL} - 8em)`,
                        },
                        "@media (orientation: landscape)": {
                            maxHeight: {
                                xs: "120svh",
                                md: `calc(100svh - ${HEADER_HEIGHT_FULL} - 8em)`,
                            },
                        },
                        overflow: "hidden",
                    }}
                >
                    <Image
                        src={ladySrc.src}
                        alt={t("about.image1")}
                        width={ladySrc.width}
                        height={ladySrc.height}
                        loading={"eager"}
                        style={{
                            width: "100%",
                            height: "auto",
                            objectFit: "cover",
                            objectPosition: "center center",
                        }}
                    />
                </Box>
            </Box>
        </Box>
	);
};

export default About;
